import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Sidebar } from "../partials/Sidebar";
import { Navbar } from "../partials/Navbar";
import * as gameService from "../services/game.service";
import * as subscribersService from "../services/subscribers.service";
import { formatDateToString } from "../utils/common";
import { PuzzleIcon, UsersIcon, UserGroupIcon } from "@heroicons/react/outline";
import SubsDayChart from "./Report/SubscriptionsReport/SubsDayChart";
import AdsDayChart from "./Report/adsSubscribers/AdsDayChart";
import * as authActions from "../redux/actions/authActions";
import Layout from "../layout";
export default function Home() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [gamesCount, setGamesCount] = useState(0);
  const [subscribersCount, setSubscribersCount] = useState(0);
  const [todaySubscribers, setTodaySubscribers] = useState(0);
  const now = formatDateToString(new Date());
  const accessToken = useSelector((state) => state.auth.user.accessToken);
  const userDetails = useSelector((state) => state.auth.user);
  const isAuthorized = useSelector((state) => state.auth.authenticated);
  const dispatch = useDispatch()
   const clearState = () => {
      dispatch(authActions.clearState());
    };
  const getGames = () => {
    gameService.list(1, 1, accessToken)
    .then((response) => {
      if (response.status === 200) {
        setGamesCount(response.data.data.count);
        console.log(response.data.data);
      } else if(response.data.status===401) {
        console.log(response);
        clearState()
      }
    }).catch((error) => {
                      console.log(error)
                      if(error.response.status === 401) {
                          console.log(error.repsonse);
                            dispatch(clearState())
                      }
                  })

  };
  const getSubscribers = () => {
    subscribersService.list(1, 1, "1-1-2000", now, accessToken)
    .then((response) => {
      if (response.status === 200) {
        setSubscribersCount(response.data.data.count);
        console.log(response.data.data);
      } else if(response.data.status===401) {
        console.log(response);
        clearState()
      }
    })
    .catch((error) => {
                      console.log(error)
                      if(error.response.status === 401) {
                          console.log(error.repsonse);
                            dispatch(clearState())
                      }
                  })
  };

  const getTodaySubscribers = () => {
    subscribersService.list(1, 1, now, now, accessToken).then((response) => {
      if (response.status === 200) {
        setTodaySubscribers(response.data.data.count);
        console.log(response.data.data);
      }
    })
    .catch((error) => {
                      console.log(error)
                      if(error.response.status === 401) {
                          console.log(error.repsonse);
                            dispatch(clearState())
                      }
                  })
  };

  useEffect(() => {
    if(isAuthorized){
      getGames();
      getSubscribers();
      getTodaySubscribers();
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout>
      <div>
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        <Navbar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen } isAuthorized={isAuthorized} userDetails={userDetails}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <h1 className="text-2xl font-semibold text-gray-900">Dashboard</h1>
          </div>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            {/* Replace with your content */}
            <div className="py-4">
              <div className="bg-white overflow-hidden shadow rounded-lg">
                <div className="figures grid p-3 lg:p-6 sm:grid-cols-3 grid-cols-3 gap-6">
                  <div className="figure flex flex-col lg:flex-row items-center justify-between bg-[#F7AD0D] p-4 lg:p-8 text-center rounded-lg">
                    <div className="text-4xl w-full lg:w-1/4 flex justify-center items-center h-1/2 lg:h-auto font-medium text-white">
                      <PuzzleIcon className="h-10 lg:h-14 w-12 lg:w-14" />
                    </div>
                    <div className="w-fll lg:w-3/4 h-1/2 lg:h-auto flex flex-col justify-center text-center">
                      <div className="text-2xl lg:text-4xl font-semibold text-white">
                        {gamesCount}
                      </div>
                      <div className="text-md lg:text-lg font-bold mt-2 text-gray-100">
                        Games
                      </div>
                    </div>
                  </div>
                  <div className="figure flex flex-col lg:flex-row items-center bg-[#8a4af3] p-8 text-center rounded-lg">
                    <div className="text-4xl w-full lg:w-1/4 flex justify-center items-center h-1/2 lg:h-auto font-medium text-white">
                      <UserGroupIcon className="h-10 lg:h-14 w-12 lg:w-14" />
                    </div>
                    <div className="w-fll lg:w-3/4 h-1/2 lg:h-auto flex flex-col justify-center text-center">
                      <div className="text-2xl lg:text-4xl font-semibold text-white">
                        {subscribersCount}
                      </div>
                      <div className="text-md lg:text-lg font-bold mt-2 text-gray-100">
                        Total Subscribers
                      </div>
                    </div>
                  </div>

                  <div className="figure flex flex-col lg:flex-row items-center justify-between bg-[#4caf50] p-4 lg:p-8 text-center rounded-lg">
                    <div className="text-4xl w-full lg:w-1/4 flex justify-center items-center h-1/2 lg:h-auto font-medium text-white">
                      <UsersIcon className="h-10 lg:h-14 w-12 lg:w-14" />
                    </div>
                    <div className="w-fll lg:w-3/4 h-1/2 lg:h-auto flex flex-col justify-center text-center">
                      <div className="text-2xl lg:text-4xl font-semibold text-white">
                        {todaySubscribers}
                      </div>
                      <div className="text-md lg:text-lg font-bold mt-2 text-gray-100">
                        Today's Subscribers
                      </div>
                    </div>
                  </div>
                </div>
                <div className="charts grid p-6 grid-cols-1 lg:grid-cols-2 gap-6">
                  <div>
                    <SubsDayChart accessToken={accessToken}/>
                  </div>
                  <div>
                    <AdsDayChart accessToken={accessToken}/>
                  </div>
                </div>
              </div>
            </div>
            {/* /End replace */}
          </div>
        </Navbar>
      </div>
    </Layout>
  );
}
